import type {ReactElement} from 'react';

export const DEFAULT_ITEMS_PER_ROW = 3;

export interface BaseContextualMenuGridPanelProps {
  items: ContextualMenuGridPanelItem[];
  itemsPerRow?: number;
  selectedId?: string;
  isLoading?: boolean;
  showNameWithThumb?: boolean;
  onSelected: (id: string) => void;
  subOptionToShow?: ReactElement;
  hasSubOptions?: boolean;
  containerClass?: string;
  hasCustomDimensions?: boolean;
  hasBorder?: boolean;
}

export interface ContextualMenuGridPanelItem {
  id: string;
  name?: string;
  thumb: ReactElement;
}
